import { useRive, EventType, RiveEventType, Layout, Fit, Alignment } from '@rive-app/react-webgl';
import { useCallback, useEffect } from 'react';
import  { EVENT_VOICEDSUBMIT, useAudioService}  from "../com/akavirtual/deai/core/AudioService";
import  {useDEAIService}  from "../com/akavirtual/deai/core/DEAIService";
import { Config } from '../com/akavirtual/deai/Config';
const RiveDeAIMainOverlayUIEvents = {
    VoiceTalkStart:'VoiceTalkStart',
    VoiceTalkEnd:'VoiceTalkEnd',
}

export const DeAIMainOverlayUI = (options) => {
    const {rive, RiveComponent} = useRive(options);

    const audioService = useAudioService();
    const deAIService = useDEAIService(Config.ENDPOINT);

    useEffect(() => {
        if (rive) {
            const onRiveEventReceived = (riveEvent) => {
                const eventData = riveEvent.data;
                const eventProperties = eventData.properties;
                if (eventData.type === RiveEventType.General) {
                    console.log("Event name", eventData.name);
                    // Added relevant metadata from the event
                    // console.log("Rating", eventProperties.rating);
                    // console.log("Message", eventProperties.message);
                    if(eventData.name === RiveDeAIMainOverlayUIEvents.VoiceTalkStart) {
                        audioService.startRecording();
                    } else if(eventData.name === RiveDeAIMainOverlayUIEvents.VoiceTalkEnd) {
                        audioService.stopRecording();
                    }
                } else if (eventData.type === RiveEventType.OpenUrl) {
                    window.location.href = eventData.url;
                }
            };
            rive.on(EventType.RiveEvent, onRiveEventReceived);
        }
        const onVoiceSumbit = (e)=>{
            const blob = new Blob(e.message, { 'type' : 'audio/ogg; codecs=opus' });
            deAIService.submitVoice(blob);
        }
        audioService.addEventListener(EVENT_VOICEDSUBMIT, onVoiceSumbit);
        return () => {
            audioService.removeEventListener(EVENT_VOICEDSUBMIT, onVoiceSumbit);
        }
    }, [rive, audioService, deAIService]);

    return (
        <div id="riveView">
            <RiveComponent />
        </div>
    );
};